import { useAccount, useDisconnect } from 'wagmi';
import { useOnboardSteps } from '../../hooks/useOnboardSteps';
import { addressTooltip } from '../../lib/tooltips';
import { Alert } from '../Alert';
import { Button } from '../catalyst-ui-kit/button';
import { ResponsiveModal } from '../ResponsiveModal/ResponsiveModal';
import { Tooltip } from '../Tooltip/Tooltip';

export const WalletBlockedModalUi = ({
  isGeoblocked,
  isNotWhitelisted,
  address,
  onSignOut,
}: {
  isGeoblocked: boolean;
  isNotWhitelisted: boolean;
  address?: string | undefined;
  onSignOut: () => void;
}) => {
  const getAlertContent = () => {
    if (isGeoblocked) {
      return (
        <Alert variant="warning">
          Ethereal is not available to residents, citizens or companies incorporated in the United
          States of America, Australia and others restricted regions.
        </Alert>
      );
    }

    if (isNotWhitelisted) {
      return (
        <Alert variant="warning">
          You are not currently whitelisted for the Ethereal restricted rollout. Please check you
          have connected with the right account{' '}
          {address ? (
            <>
              (
              <Tooltip content={addressTooltip(address)}>
                <span className="italic text-contentSecondary">
                  {address.slice(0, 6)}...{address.slice(-4)}
                </span>
              </Tooltip>
              )
            </>
          ) : null}{' '}
          or come back during the public release.
        </Alert>
      );
    }

    return null;
  };

  return (
    <ResponsiveModal
      open={true}
      onClose={() => {}}
      title={isGeoblocked ? 'Unavailable in Your Region' : 'Access Restricted'}
      panelClassName="sm:max-w-[406px]"
      childrenContainerClassName="flex flex-col gap-5"
      hideCloseButton={true}
    >
      <div>{getAlertContent()}</div>

      <Button outline onClick={onSignOut}>
        Sign Out
      </Button>
    </ResponsiveModal>
  );
};

/**
 * Displays a notice to users who are geoblocked or not whitelisted.
 */
export const WalletBlockedModal = () => {
  const { isGeoblocked, isNotWhitelisted } = useOnboardSteps();
  const { disconnect } = useDisconnect();

  const { address } = useAccount();

  const isBlocked = isGeoblocked || isNotWhitelisted;

  const handleSignOut = () => {
    disconnect();
  };

  if (!isBlocked) return null;

  return (
    <WalletBlockedModalUi
      isGeoblocked={isGeoblocked}
      isNotWhitelisted={isNotWhitelisted}
      address={address}
      onSignOut={handleSignOut}
    />
  );
};
